export default __webpack_public_path__ + "static/blog_author-3c410acaaf0e9b286a04cf88bb2b77ae.jpg";